import UnderwritingRequirementsAlert from "../../components/alerts/UnderwritingRequirementsAlert";
import Screen from "../../components/layout/Screen";
import ScreenContent from "../../components/layout/ScreenContent";
import TitledHeader from "../../components/layout/TitledHeader";
import SubmittedFinancingRequestsSection from "../DashboardHomeScreen/SubmittedFinancingRequestsSection";

const FinancingRequestsScreen = () => {
  return (
    <Screen
      sx={{
        position: "absolute",
        left: 0,
        width: "100%",
        backgroundColor: "#f5f8fa",
        height: "100%",
      }}
    >
      <TitledHeader
        title={"My Financing Requests"}
        description="Track the status of your submitted financing requests."
      />
      <ScreenContent
        maxWidth={"xl"}
        sx={{
          width: "100%",
          pb: 14,
          pt: 2,
          // px: isMobile ? 0 : 5,
          margin: "0px auto",
        }}
      >
        <UnderwritingRequirementsAlert />
        <SubmittedFinancingRequestsSection mt={2.5} />
      </ScreenContent>
    </Screen>
  );
};

export default FinancingRequestsScreen;
